import { Box } from "@mui/material"
import React, { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import type { PriceChangeFilterInput, PriceChangeFilterLookupItem } from "@/graphql/codegen/graphql"

interface CustomerFilterChipsProps {
  selectedCustomerIds: string[]
  customers?: PriceChangeFilterLookupItem[]
  onRemove: (key: keyof PriceChangeFilterInput, value?: string) => void
}

const CustomerFilterChips: React.FC<CustomerFilterChipsProps> = ({ selectedCustomerIds, onRemove, customers }) => {
  const customerList = useMemo(
    () => customers?.filter((customer) => selectedCustomerIds.includes(customer.id)),
    [selectedCustomerIds, customers]
  )

  return (
    <Box className='flex flex-wrap gap-3'>
      {customerList?.map((customer) => (
        <FilterChip
          key={`pricing.customer-filter-chips.customer-${customer.id}`}
          data-testid={`pricing.customer-filter-chips.customer-${customer.id}`}
          label={`Customer: ${customer.label}`}
          onDelete={() => onRemove("customerIds", customer.id)}
        />
      ))}
    </Box>
  )
}

export default CustomerFilterChips
